import React from 'react';
import html2canvas from 'html2canvas';
import mosaic from './utils/mosaic';

const quan = 2; //马赛克的大小
const num = 5; //一次操作包含马赛克的个数

class App extends React.Component {
  static defaultProps = {
    className: '',
    options: {
      useCORS: true,
      scale: 1 //不要使用默认的 window.devicePixelRatio，不然会造成双倍图问题
    },
    type: 'line',
    lineWidth: 2,
    strokeStyle: 'red',
    width: 600,
    height: 450,
    ratio: 0.9,
    clipboard: true,
    editorDidMount: () => { }
  };

  ctx = null; //canvas context

  drawing = false; //是否在绘制

  imageDataCache = [];

  componentDidMount() {
    this.auto();
    this.props.editorDidMount({
      autoScreenShot: this.auto,
      getImageURL: this.getImageURL,
      context: this.ctx
    });
  }

  auto = () => {
    const { width, height, options } = this.props;
    html2canvas(document.documentElement, options).then(canvas => {
      //根据浏览器窗口裁剪，宽度充满，高度自适应
      const winWidth = window.innerWidth, winHeight = window.innerHeight, winScrollY = window.scrollY;
      const widthRatio = width / winWidth, _height = winHeight * widthRatio;
      const distHeight = _height < height ? _height : height;
      this.ctx.drawImage(canvas, 0, winScrollY, winWidth, winHeight, 0, 0, width, distHeight);
    });
  }

  getImageURL = () => {
    const { ratio } = this.props;
    return this.canvas.toDataURL('image/jpeg', ratio);
  }

  // handlePaste = (event) => {
  //   if (!this.props.clipboard) return;
  //   let items = [].slice.call(event.clipboardData.items);
  //   let imageItems = items.filter(item => {
  //     return item.type.startsWith('image/');
  //   }).map(item => ({
  //     type: item.type,
  //     file: item.getAsFile()
  //   }));
  //   if (imageItems.length < 1) return;
  //   event.preventDefault();
  //   //处理image Data数据
  //   debugger;
  // }

  handleMounted = (el) => {
    if (!el) return;
    this.canvas = el;
    this.ctx = el.getContext('2d');
  }

  handleMouseDown = (ev) => {
    this.drawing = true;
    const { width, height } = this.canvas;
    const { x, y } = this.canvas.getBoundingClientRect();
    this.canvasX = x;
    this.canvasY = y;
    const currentImageData = this.ctx.getImageData(0, 0, width, height);
    this.imageDataCache.push(currentImageData);
    ev = ev || window.event;
    this.dx = ev.clientX - x;
    this.dy = ev.clientY - y;
    if (this.props.type == 'line') {
      this.ctx.beginPath();
      const { lineWidth, strokeStyle } = this.props;
      this.ctx.lineWidth = lineWidth;
      this.ctx.strokeStyle = strokeStyle;
      this.ctx.moveTo(this.dx, this.dy);
    } else {
      mosaic(this.ctx, width, height, this.dx, this.dy, quan, num);
    }
  }

  handleMouseUp = () => {
    this.drawing = false;
  }

  handleMouseMove = (ev) => {
    if (!this.drawing) return;
    ev = ev || window.event;
    const { width, height } = this.canvas;
    const mx = ev.clientX - this.canvasX;
    const my = ev.clientY - this.canvasY;
    if (this.props.type == 'line') {
      this.ctx.lineTo(mx, my);
      this.ctx.stroke();
    } else if (Math.pow(this.dx - mx, 2) + Math.pow(this.dy - my, 2) >= Math.pow(quan * num, 2)) { //(quan*马赛克个数*2)的平方
      mosaic(this.ctx, width, height, mx, my, quan, num);
      this.dx = mx;
      this.dy = my;
    }
  }

  render() {
    const { className, width, height } = this.props;

    return <canvas
      data-html2canvas-ignore
      className={className}
      width={width}
      height={height}
      ref={this.handleMounted}
      //onPaste={this.handlePaste}
      onMouseDown={this.handleMouseDown}
      onMouseUp={this.handleMouseUp}
      onMouseMove={this.handleMouseMove}
    />;
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/index.js